import React, { useState } from 'react';
import { Locations } from '../components/sections/Locations';
import { LongpontModal } from '../components/sections/LongpontModal';
import { MennecyModal } from '../components/sections/MennecyModal';
import { SeoContent } from '../components/sections/SeoContent';

const LocationsPage = () => {
  const [longpontOpen, setLongpontOpen] = useState(false);
  const [mennecyOpen, setMennecyOpen] = useState(false);

  return (
    <div className="pt-32 sm:pt-40" data-testid="locations-page">
      <Locations
        onOpenLongpont={() => setLongpontOpen(true)}
        onOpenMennecy={() => setMennecyOpen(true)}
      />
      <SeoContent />
      <LongpontModal open={longpontOpen} onClose={() => setLongpontOpen(false)} />
      <MennecyModal open={mennecyOpen} onClose={() => setMennecyOpen(false)} />
    </div>
  );
};

export default LocationsPage;
